import { ATTENDED, ATTENDING, CONFIRMED, NOT_ATTENDING, NO_SHOW, WAITING_LIST } from '../attending-statuses'
import campaignActionSharedGetters from '../../../campaign-action-shared/store/getters'
import groupBy from 'lodash/groupBy'

export default {
  ...campaignActionSharedGetters,

  attendeeHasRsvped: (state) => {
    return state.attendingStatus !== null
  },

  attending: (state) => {
    return [ATTENDING, CONFIRMED, ATTENDED].includes(state.attendingStatus)
  },

  eventCanBeShared: (state) => {
    return state.eventStatus.publiclyVisible && !state.eventStatus.cancelled && !state.eventStatus.sharingDisabled
  },

  notAttending: (state) => {
    return [NOT_ATTENDING, NO_SHOW].includes(state.attendingStatus)
  },

  onWaitlist: (state) => {
    return state.attendingStatus === WAITING_LIST
  },

  shiftedEvent: (state) => {
    return state.event.shifts.length > 0
  },

  shiftsByDay: (state) => {
    return groupBy(state.event.shifts, 'day')
  }
}
